import { Algodon1 } from "./Icons/Algodon";
import { Algodon2 } from "./Icons/Algodon";
import { Algodon3 } from "./Icons/Algodon";
import { Algodon4 } from "./Icons/Algodon";
import { Algodon5 } from "./Icons/Algodon";

export const PreguntasCardsAlgodon = () => {
  const cardsAlgodon = [
    {
      id: 1,
      text: "Lavado corto con agua fría.",
      img: <Algodon1 />,
    },
    {
      id: 2,
      text: "Usar niveles moderados de jabón y suavizante.",
      img: <Algodon2 />,
    },
    {
      id: 3,
      text: "No usar lejía ni jabones abrasivos.",
      img: <Algodon3 />,
    },
    {
      id: 4,
      text: "Colgar la prenda húmeda en una percha.",
      img: <Algodon4 />,
    },
    {
      id: 5,
      text: "Se puede utilizar plancha suave y vapor.",
      img: <Algodon5 />,
    },
  ];

  return (
    <>
      {cardsAlgodon.map((item) => (
        <li key={item.id}>
          <picture>{item.img}</picture>
          <p>{item.text}</p>
        </li>
      ))}
    </>
  );
};
